import { Component, input, OnInit, output } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-client-selector',
  templateUrl: './client-selector.component.html',
  imports: [MatSelectModule, FormsModule],
  styleUrls: ['./client-selector.component.scss'],
})
export class ClientSelectorComponent implements OnInit {
  ngOnInit(): void {
    this.currentClient = this.clients()[0] || '';
  }
  clientChanged = output<string>();
  currentClient = "";
  clients = input.required<string[]>();

  updateClient(val: string) {
    this.currentClient = val;
    this.clientChanged.emit(val);
  }
}
